import React from 'react';

import FormInvalid from './FormInvalid';
import TextEditor from './TextEditor';

type Props = {
    field: string;
    value: string;
    label: string | JSX.Element;
    error: string;
    handleChange: (text: string) => void;
    required?: boolean;
    disabled?: boolean;
};

function FormGroupTextEditor({ field, value, label, error, handleChange, required = false, disabled = false }: Props) {
    const hasError = (error ?? false) !== false;

    return (
        <div className="form-group text-editor">
            <label htmlFor={field}>
                {label} {required === true && <span className="text-danger text-sm">*</span>}
            </label>
            <input type="hidden" className={`form-control hidden ${hasError ? 'is-invalid' : ''}`} />
            <TextEditor id={field} value={value} onEditorChange={handleChange} disabled={disabled} />
            {hasError && <FormInvalid message={error} />}
        </div>
    );
}

export default FormGroupTextEditor;
